import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';
import { PLANS, SHARED, planFeatures } from '../utils/product';
import { useLeadSignup } from './LeadSignupContext';

const PlanCards = ({ id = 'plano' }) => {
  const { openSignup } = useLeadSignup();

  return (
    <div id={id} className="grid md:grid-cols-3 gap-6">
      {PLANS.map((plan) => (
        <article
          key={plan.id}
          className={`relative card p-6 lg:p-8 flex flex-col ${plan.highlight ? 'ring-2 ring-brand-500 shadow-glow' : ''}`}
        >
          <span
            className={`self-start mb-4 ${plan.highlight
              ? 'badge !bg-accent-400 !text-ink-900 !border-accent-500'
              : 'badge-brand'}`}
          >
            {plan.tag}
          </span>
          <h3 className="font-display text-xl font-bold text-ink-900">{plan.name}</h3>
          <p className="text-ink-500 text-sm mt-2 leading-relaxed">{plan.forWho}</p>
          <div className="mt-5 flex items-baseline gap-1">
            <span className="font-display text-4xl font-extrabold text-brand-700">{plan.priceLabel}</span>
            <span className="text-ink-500">{plan.priceSuffix}</span>
          </div>
          <p className="mt-2 text-sm text-ink-500">
            {plan.stops} paradas · extra {plan.extraStopLabel}
          </p>
          <ul className="mt-6 space-y-3 flex-1">
            {planFeatures(plan).map((f) => (
              <li key={f} className="flex items-start gap-2 text-sm text-ink-700">
                <CheckIcon className="h-5 w-5 text-brand-600 shrink-0 mt-0.5" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <button
            type="button"
            onClick={() => openSignup(plan.id)}
            className={`mt-8 w-full text-center ${plan.highlight ? 'btn-primary' : 'btn-secondary'}`}
          >
            Quero o {plan.name}
          </button>
        </article>
      ))}
      <p className="md:col-span-3 text-center text-sm text-ink-500 leading-relaxed">
        Em todos os planos: pacote até {SHARED.maxSize} e {SHARED.maxWeight}. {SHARED.doorRule} Extra além das paradas inclusas é cobrado por parada.
      </p>
    </div>
  );
};

export default PlanCards;
